module.exports = __webpack_public_path__ + "img/5.9f7a552e.jpg";